export const tools = [
    {
        title: 'LibOPF',
        description: 'LibOPF is a library of functions and programs for free usage in the design of optimum-path forest classifiers.',
        color: '#4a00d6',
        img: 'libopf.png',
        url: 'https://github.com/jppbsi/LibOPF'
    },
    {
        title: 'LibDEEP',
        description: 'LibDEEP is a C deep learning library for the development of artificial intelligence-based techniques.',
        color: '#3042e6',
        img: 'libdeep.png',
        url: 'https://github.com/jppbsi/LibDEEP'
    },
    {
        title: 'LibOPT',
        description: 'LibOPT is a C optimization library for the development of metaheuristic-based techniques.',
        color: '#1a79f3',
        img: 'libopt.png',
        url: 'https://github.com/jppbsi/LibOPT'
    },
    {
        title: 'LibDEV',
        description: 'LibDEV is an integration library, built to assimilate LibOPF, LibDEEP and LibOPT together.',
        color: '#4a00d6',
        img: 'libdev.png',
        url: 'https://github.com/jppbsi/LibDEV'
    },
    {
        title: 'NALP',
        description: 'NALP is a Python easy-to-pack solution that covers natural adversarial language processing.',
        color: '#3042e6',
        img: 'nalp.png',
        url: 'https://github.com/gugarosa/nalp'
    },
    {
        title: 'Opytimizer',
        description: 'Opytimizer is a Python library for the development of meta-heuristic optimization techniques.',
        color: '#1a79f3',
        img: 'opytimizer.png',
        url: 'https://github.com/gugarosa/opytimizer'
    },
    {
        title: 'OPFython',
        description: 'OPFython is a Python-inspired implementation of the Optimum-Path Forest classifier.',
        color: '#4a00d6',
        img: 'opfython.png',
        url: 'https://github.com/gugarosa/OPFython'
    },
    {
        title: 'Learnergy',
        description: 'Learnergy is a Python-inspired package for the development of energy-based machine learning models.',
        color: '#3042e6',
        img: 'learnergy.png',
        url: 'https://github.com/gugarosa/learnergy'
    },
    {
        title: 'Opytimark',
        description: 'Opytimark is a Python library consisting of optimization benchmarking functions.',
        color: '#1a79f3',
        img: 'opytimark.png',
        url: 'https://github.com/gugarosa/opytimark'
    },
    {
        title: 'Dualing',
        description: 'Dualing is a Python library that implements dual-based neural learning.',
        color: '#4a00d6',
        img: 'dualing.png',
        url: 'https://github.com/gugarosa/dualing'
    },
    {
        title: 'Textfier',
        description: 'Textfier provides an easier interface to text-based modifiers.',
        color: '#3042e6',
        img: 'textfier.png',
        url: 'https://github.com/gugarosa/textfier'
    },
    {
        title: 'Statys',
        description: 'Statistical analyzers to provide more robust comparisons between Machine Learning techniques.',
        color: '#1a79f3',
        img: 'statys.png',
        url: 'https://github.com/gugarosa/statys'
    }
]